// extracted by mini-css-extract-plugin
module.exports = {"cont":"hero-module--cont--2yZKy","textCont":"hero-module--textCont--Xj0DJ","load":"hero-module--load--67Q0K","imgCont":"hero-module--imgCont--3gEMe"};